import { Activity, Plan } from 'sr-types/lib/production/v1/graphql';
import { extractItemId } from '../../common/utils/commonUtils';

export const getProductionKeyActivities = ({ plans, keyActivities }: { plans: Plan[]; keyActivities: Activity[] }) => {
    const plan = plans?.[0];

    if (!plan?.keyActivities || !plan?.activities) return keyActivities || [];
    const activityMap = new Map(plan.activities.map((a) => [extractItemId(a), a]));
    return plan.keyActivities.map((keyActivity) => activityMap.get(extractItemId(keyActivity)));
};
